import React , {useEffect,useState} from "react";
import { useParams } from 'react-router-dom';
import InstructorScheduleDays from "../schedule/scheduledaysforstudent";
import { getIdData } from "../../../lib/studentinfo";
import PageNotes from "../../pages/common/pagenotesnew";
import Student12TopMenu from "../studentInfo/student12topmenu"
import Student911TopMenu from "../studentInfo/student911topmenu"
import { useAuth } from "../../../usercontext";

export default function InstructorStudentSchedule() {

  let { slug } = useParams();
  const [isStudent911, setisStudent911] = useState(false);
  const [isStudent12, setisStudent12] = useState(false);
  const { profile, setProfile } = useAuth();

  async function GetData() {
    const info = await getIdData(slug);
    if (info[0].role === "Student911") {
      setisStudent911(true);
    } else if (info[0].role === "Student12") {
      setisStudent12(true);
    }
  }
   
    useEffect(() => {
      GetData();
    }, []);

  return (
    <>
    {isStudent911 && <Student911TopMenu slug={slug} activeMenu={"Schedule"} /> }
    {isStudent12 && <Student12TopMenu slug={slug} activeMenu={"Schedule"} /> }
    <PageNotes
        type={"Instructor"}
        pageName={"Schedule"}
        studentId={slug}
        instructorId={profile.id}
      />
    <div className="tak-instruct-group">
      <div className="row">
        <div className="col-md-12">
          <InstructorScheduleDays slug={slug}/>
        </div>
      </div>
    </div>
    </>
  );
}
